var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-page',{attrs:{"id":"notfound","title":_vm.$t('not_found.title'),"sideimage":"@/assets/img/aboutus/consultant-work.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }